import { createWidget } from '@alfa-bank/site-util-create-widget/create-widget';
import { OneFieldFioDesktop } from '@alfa-bank/site-form-one-field-fio/desktop';

import { FioDesktop } from '../form-fio/desktop';

import type { IDeps, TFio } from './models';
import { Fio } from './fio';

export const FioFieldDesktop = createWidget<IDeps, TFio>({
    FioThreeField: FioDesktop,
    OneFieldFio: OneFieldFioDesktop,
})(Fio);
